import { isBrowser } from './browser';

/**
 * Send event to Google Analystic
 *
 * @param  {String} action Action type
 * @param  {String} label  Event label
 * @return {void}
 */
export const sendGAEvent = (action, label, category = 'ACL O2O') => {
  window.ga('send', 'event', {
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
  });
};

/**
 * Send timming to Google Analystic
 *
 * @param  {String} timmingVar   Timming var
 * @param  {Number} time         Time
 * @return {void}
 */
export const sendGATimming = (timmingVar, time, category = 'ACL O2O') => {
  window.ga('send', 'timing', {
    timingCategory: category,
    timingVar: timmingVar,
    timingValue: time,
  });
};

/**
 * Send a custom dimension to Google Analystic
 *
 * @param  {String} Custom dimension index
 * @param {String} Value passed to CD
 */
export const sendGACustom = (index, value) => {
  window.ga('set', `dimension${index}`, value);
};

/**
 *
 * @param {String} label Event Name
 * @param {String} action Action Name
 * @param {*} value
 * @param {String} category Category Name
 */
export const pushDataLayer = (label, action, value, category = 'ACL O2O') => {
  if (!isBrowser()) return;
  window.dataLayer.push({ event: label, action, value });
  window.ga('send', 'event', {
    eventCategory: category,
    eventAction: action,
    eventLabel: label,
    eventValue: value,
  });
};

/**
 *
 * @param {String} label Event Name
 * @param {String} value
 */
export const pushHashedCuid = (label, value) => {
  if (!isBrowser()) return;
  window.dataLayer.push({ event: label, [label]: value });
  window.ga('send', 'event', {
    eventLabel: label,
    [label]: value,
  });
};